import { render } from "./SignupForm.vue?vue&type=template&id=b9b74f38&ts=true"
import script from "./SignupForm.vue?vue&type=script&lang=ts"
export * from "./SignupForm.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__